import dateRange from './dateRanges'

export default {
  getMedianValue(arr) {
    if (arr.length <= 0) return 0;

    const sorted = [...arr].sort((a, b) => a - b);

    if (sorted.length % 2 === 1) {
      return sorted[Math.floor(sorted.length / 2)];
    }

    return (sorted[sorted.length / 2] + sorted[sorted.length / 2 - 1]) / 2;
  },
  formatToDaysAndHoursFromSeconds(delta) {
    let tmp = delta;

    const secondsInMinute = 60;
    const secondsInHour = 3600;
    const secondsInDay = 3600 * 24;

    const countDays = Math.floor(tmp / secondsInDay);
    tmp -= countDays * secondsInDay;

    const countHours = Math.floor(tmp / secondsInHour);
    tmp -= countHours * secondsInHour;

    const countMinutes = Math.floor(tmp / secondsInMinute);
    tmp -= countMinutes * secondsInMinute;

    if (countDays > 0) {
      return `${countDays}д ${countHours}ч`;
    }

    if (countHours > 0) {
      return `${countHours}ч ${countMinutes}м`;
    }

    return `${countMinutes}м`;
  },
  formatToDaysAndHoursFromMinutes(deltaMinutes) {
    let tmp = deltaMinutes;

    const minutesInHour = 60;
    const minutesInDay = 60 * 24;

    const countDays = Math.floor(tmp / minutesInDay);
    tmp -= countDays * minutesInDay;

    const countHours = Math.floor(tmp / minutesInHour);
    tmp -= countHours * minutesInHour;

    const countMinutes = tmp;

    if (countDays > 0) {
      return `${countDays}д ${countHours}ч`;
    }

    if (countHours > 0) {
      return `${countHours}ч ${countMinutes}м`;
    }

    return `${countMinutes}м`;
  },

  prepare(agreements) {
    return agreements
      .map(a => {
        const created = new Date(a.createdAt);
        const answered = a.answeredAt ? new Date(a.answeredAt) : new Date();
        const deltaMinutes = this.getDeltaInMinutes(created, answered);
        const isAnswered = !!a.answeredAt;
        const { isAgreed } = a;

        return { created, answered, deltaMinutes, isAnswered, isAgreed };
      });
  },
  getDeltaInMinutes(startDate, endDate = new Date()) {
    return dateRange.sumPeriodsInMinutes(
      [[startDate, endDate]],
      endDate
    );
  },
  getStats(agreements) {
    const preStats = this.prepare(agreements);

    const answered = preStats.filter(a => a.isAgreed !== null);
    const sumTime = dateRange.sumPeriodsInMinutes(answered.map(({ created, answered }) => [created, answered]), new Date());
    const countTotal = answered.length;
    const relSum = answered.reduce((acc, val) => acc + val.deltaMinutes, 0);
    const avgTime = countTotal > 0 ? Math.ceil(relSum / countTotal) : 0;
    const countConfirmed = answered.filter(s => s.isAgreed === true).length;
    const countRejected = answered.filter(s => s.isAgreed === false).length;
    const medianTime = this.getMedianValue(answered.map(s => s.deltaMinutes));

    const notAnswered = preStats.filter(a => a.isAgreed === null);
    const countNotAnswered = notAnswered.length;
    const waitTime = Math.max(0, ...notAnswered.map(a => a.deltaMinutes));

    return {
      timeMedian:   this.formatToDaysAndHoursFromMinutes(medianTime), // eslint-disable-line
      timeAvg:      this.formatToDaysAndHoursFromMinutes(avgTime),    // eslint-disable-line
      timeTotal:    this.formatToDaysAndHoursFromMinutes(sumTime),    // eslint-disable-line
      cntConfirmed: countConfirmed,                                   // eslint-disable-line
      cntRejected:  countRejected,                                    // eslint-disable-line
      cntWaiting:   countNotAnswered,                                 // eslint-disable-line
      timeWaiting:  this.formatToDaysAndHoursFromMinutes(waitTime),   // eslint-disable-line
    };
  },
  getTitles() {
    return {
      timeMedian:   { title: 'Медианное время согласования',  icon: 'stats/chart' }, // eslint-disable-line
      timeAvg:      { title: 'Среднее время согласования',    icon: 'stats/chart' }, // eslint-disable-line
      timeTotal:    { title: 'На все согласования ушло',      icon: 'stats/clock' }, // eslint-disable-line
      cntConfirmed: { title: 'Согласовано',                   icon: 'stats/check' }, // eslint-disable-line
      cntRejected:  { title: 'Отклонено',                     icon: 'stats/cross' }, // eslint-disable-line
      cntWaiting:   { title: 'Ожидают согласования',          icon: 'stats/cross' }, // eslint-disable-line
      timeWaiting:  { title: 'Время ожидания',                icon: 'stats/clock' }, // eslint-disable-line
    };
  },
}
